import React, { useState } from "react";
import { COMPANIES } from "../const/constants";
import { FirebaseService } from "../services/firebaseService";

const Generator = () => {
  const [loading, setLoading] = useState(false);
  const [invoiceData, setInvoiceData] = useState({
    companyId: COMPANIES[0].id,
    billToName: "",
    billToEmail: "",
    customerPhone: "",
    invoiceNumber: Math.floor(100000 + Math.random() * 900000).toString(),
    invoiceDate: new Date().toLocaleDateString(),
    dueDate: new Date().toLocaleDateString(),
    items: [{ description: "Logo Plus", amount: 99 }],
    totalAmount: 99,
  });

  const [generatedLink, setGeneratedLink] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInvoiceData((prev) => ({ ...prev, [name]: value }));
  };

  const handleItemChange = (index, e) => {
    const { name, value } = e.target;
    const newItems = [...invoiceData.items];
    newItems[index][name] = name === "amount" ? parseFloat(value) || 0 : value;

    const newTotal = newItems.reduce(
      (sum, item) => sum + (item.amount || 0),
      0,
    );

    setInvoiceData((prev) => ({
      ...prev,
      items: newItems,
      totalAmount: newTotal,
    }));
  };

  const addItem = () => {
    setInvoiceData((prev) => ({
      ...prev,
      items: [...prev.items, { description: "", amount: 0 }],
    }));
  };

  const removeItem = (index) => {
    if (invoiceData.items.length === 1) return;
    const newItems = invoiceData.items.filter((_, i) => i !== index);
    const newTotal = newItems.reduce(
      (sum, item) => sum + (item.amount || 0),
      0,
    );
    setInvoiceData((prev) => ({
      ...prev,
      items: newItems,
      totalAmount: newTotal,
    }));
  };

  const handleGenerate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const id = await FirebaseService.createInvoice(invoiceData);
      const link = `${window.location.origin}/trademark-invoice/invoice/${id}`;
      setGeneratedLink(link);
    } catch (error) {
      alert("Error generating invoice. Check console for details.");
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(generatedLink);
    alert("Link copied to clipboard!");
  };

  return (
    <div className="container mt-5 mb-5">
      <div className="row justify-content-center">
        <div className="col-md-10">
          <div className="card shadow-lg p-4">
            <h2 className="text-center mb-4">Invoice Generator</h2>
            <form onSubmit={handleGenerate}>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Select Company</label>
                  <select
                    className="form-control"
                    name="companyId"
                    value={invoiceData.companyId}
                    onChange={handleChange}
                    required
                  >
                    {COMPANIES.map((company) => (
                      <option key={company.id} value={company.id}>
                        {company.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Invoice Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="invoiceNumber"
                    value={invoiceData.invoiceNumber}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Bill To Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="billToName"
                    value={invoiceData.billToName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Bill To Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="billToEmail"
                    value={invoiceData.billToEmail}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4">
                  <label className="form-label">Customer Phone</label>
                  <input
                    type="text"
                    className="form-control"
                    name="customerPhone"
                    value={invoiceData.customerPhone}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">Date</label>
                  <input
                    type="text"
                    className="form-control"
                    name="invoiceDate"
                    value={invoiceData.invoiceDate}
                    onChange={handleChange}
                    placeholder="MM/DD/YYYY"
                    required
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">Due Date</label>
                  <input
                    type="text"
                    className="form-control"
                    name="dueDate"
                    value={invoiceData.dueDate}
                    onChange={handleChange}
                    placeholder="MM/DD/YYYY"
                    required
                  />
                </div>
              </div>

              <div className="items-section mt-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="mb-0">Line Items</h4>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={addItem}
                  >
                    + Add Item
                  </button>
                </div>
                {invoiceData.items.map((item, index) => (
                  <div
                    key={index}
                    className="row mb-3 align-items-end border-bottom pb-3"
                  >
                    <div className="col-md-7">
                      <label className="form-label">Description</label>
                      <input
                        type="text"
                        className="form-control"
                        name="description"
                        value={item.description}
                        onChange={(e) => handleItemChange(index, e)}
                        required
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Amount ($)</label>
                      <input
                        type="number"
                        className="form-control"
                        name="amount"
                        value={item.amount}
                        onChange={(e) => handleItemChange(index, e)}
                        required
                      />
                    </div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btn-outline-danger w-100"
                        onClick={() => removeItem(index)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="row justify-content-end mt-4">
                <div className="col-md-4 text-end">
                  <div className="p-3 bg-light rounded">
                    <h5 className="mb-0">
                      Total: ${invoiceData.totalAmount.toFixed(2)}
                    </h5>
                  </div>
                </div>
              </div>

              <button
                type="submit"
                className="btn btn-primary w-100 mt-4"
                disabled={loading}
              >
                {loading ? "Generating..." : "Generate Invoice Link"}
              </button>
            </form>

            {generatedLink && (
              <div className="mt-4 p-3 bg-light border rounded">
                <h5>Invoice Link Generated!</h5>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    value={generatedLink}
                    readOnly
                  />
                  <button
                    className="btn btn-outline-secondary"
                    onClick={copyToClipboard}
                  >
                    Copy
                  </button>
                  <a
                    href={generatedLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-primary"
                  >
                    Open
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Generator;
